// client/impersonation.ts
import { impersonateUser, stopImpersonationOfUser } from "../db/a-user.js";
import * as names from "../db/names.js";
import { _subscribeCurrentUser } from "./currentUser.js";
var impersonate = async (userID, userClassName = names.adornisUserClassName) => {
  await impersonateUser(userID, userClassName)();
  await _subscribeCurrentUser();
};
var stopImpersonation = async () => {
  await stopImpersonationOfUser()();
  await _subscribeCurrentUser();
};
export {
  impersonate,
  stopImpersonation
};
